import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Redirect } from 'react-router'
import { addOrganization, deleteOrganization, getAllOrganizations } from '../redux/UserActions'

function Organizations() {
    const userSelector = useSelector(state => state.user)
    const dispatch = useDispatch()
    const [showOrganizations, setOrganizations] = useState(userSelector.allOrganizations)
    const [search, setSearch] = useState("")

    useEffect(() => {
        dispatch(getAllOrganizations(""))
    }, [])

    useEffect(() => {
        setOrganizations(userSelector.allOrganizations)
    }, [userSelector.allOrganizations])

    useEffect(() => {
        if (search !== "") {
            setOrganizations(showOrganizations.filter(org => (org.Name.toUpperCase()).includes(search.toUpperCase())))
        }
        else {
            setOrganizations(userSelector.allOrganizations)
        }
    }, [search])

    return (
        <div className="mt-10">
            <div className="mr-auto ml-auto shadow-md sm:w-8/12 md:w-8/12 lg:w-4/12 xl:w-4/12 2xl:w-4/12">
                <h1>Add a new organization</h1>
                <form className="grid grid-cols-1" onSubmit={(e) => {
                    e.preventDefault()
                    dispatch(addOrganization({
                        "Name": document.getElementById("name").value,
                        "BadMoods": 0,
                        "Admins": [],
                        "Points": {
                            "Happy": 5,
                            "Sad": 5,
                            "-5": 5,
                            "-4": 5,
                            "-3": 5,
                            "-2": 5,
                            "-1": 5,
                            "0": 5,
                            "1": 5,
                            "2": 5,
                            "3": 5,
                            "4": 5
                        },
                        "GiftRequests": [],
                        "GiftOptions": []
                    }))
                }}>
                    <input id="name" className="w-9/12 mr-auto ml-auto placeholder-opacity-5" placeholder="Name" />
                    <button type="submit" className="focus:outline-none text-white text-sm py-2.5 px-5 rounded-md bg-gray-500 hover:bg-gray-600 hover:shadow-lg mr-auto ml-auto mt-4 mb-2">Add</button>
                </form>
            </div>
            <input className="mt-10" placeholder="Search..." value={search} onChange={(e) => setSearch(e.target.value)} />
            <div className="grid sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-3 2xl:grid-cols-3 mt-16">
                {showOrganizations?.map(org =>
                    <div className="shadow-md w-8/12 ml-auto mr-auto mb-16">
                        <h1>{org.Name}</h1>
                        <h1>{"Invitation Code: " + org.InvitationCode}</h1>
                        <button
                            onClick={(e) => {
                                e.preventDefault()
                                var check = false;
                                if (window.confirm('Are you sure you want to delete the organization "' + org.Name + '" ?')) {
                                    check = true;
                                } else {
                                    check = false;
                                }
                                if (check === true) {
                                    dispatch(deleteOrganization({ "id": org.ID }))
                                }
                            }}
                            className="focus:outline-none text-white text-sm py-2.5 px-5 rounded-md bg-gray-500 hover:bg-gray-600 hover:shadow-lg mr-auto ml-auto mt-4 mb-2">Delete</button>
                    </div>)}
            </div>
        </div>
    )
}

export default Organizations
